import React from 'react';
import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import className from 'classnames/bind';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import { timeout } from '../../lazy/lazyConstants';
import styles from '../FindStores/components/FindAStoreLoader/FindAStoreLoader.css';

const cx = className.bind(styles);

export default universal(
    universalImport({
        chunkName: () => 'FindAStorePageLazy',
        path: () => path.join(__dirname, './FindAStorePage'),
        resolve: () => require.resolveWeak('./FindAStorePage'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "FindAStorePageLazy" */ './FindAStorePage'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => <Loader keepOverlay loaderClass={cx('loaderClass')} />,
        error: () => null,
        timeout,
    }
);
